import { combineReducers } from 'redux';
import {
  GET_ORDERS_INVOICES_DT,
  GET_ORDERS_INVOICES_DT_OK,
  GET_ORDERS_INVOICES_DT_ERR,
  DO_ORDERS_INVOICES_DT_CLEANUP,

  APPLY_ORDERS_INVOICES_DT_FILTERS,
  CLEAR_ORDERS_INVOICES_DT_FILTERS,
  PATCH_ORDERS_INVOICES_DT_FILTERS,
  UNSET_ORDERS_INVOICES_DT_FILTERS,
} from "./actionTypes";
import { TDtFiltersState, TDtState } from "./type";
import { TAction } from '~/types/global';

/********** DATATABLE **********/

const defaultDtState: TDtState = {
  orders: [],
  ordersError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const Dt = (state = defaultDtState, action: TAction) => {
  switch (action.type) {
    case GET_ORDERS_INVOICES_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        ordersError: null,
        isLoadInProgress: true,
      };
      break
    case GET_ORDERS_INVOICES_DT_OK:
      state = {
        ...state,
        orders: action.payload.response.orders,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_ORDERS_INVOICES_DT_ERR:
      state = {
        ...state,
        orders: [],
        totalCount: 0,
        ordersError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_ORDERS_INVOICES_DT_CLEANUP:
      state = {
        ...state,
        orders: [],
        ordersError: null,
      };
      break
  }
  return state;
}

/********** DATATABLE FILTERS **********/
// default datatable filters to be applied as the visitor first enters the screen
// most of the time we do not want to have default filters so these values will be empty
// however there may be times when we want the list filtered by default
// we want to filter by the orders id that is logged in


const defaultDtFiltersState: TDtFiltersState = {
  createdBetween: '',
  notary: null, // Will be set when filters are applied
  _set: false,
};

const DtFilters = (state = defaultDtFiltersState, action: TAction) => {
  switch (action.type) {
    case APPLY_ORDERS_INVOICES_DT_FILTERS:
      state = {
        ...action.payload.filters,
        notary: action.payload.filters.notary,
        _set: true,
      };
      break
    case CLEAR_ORDERS_INVOICES_DT_FILTERS:
      state = {
        ...defaultDtFiltersState,
        notary: state.notary,
        _set: true,
      };
      break
    case PATCH_ORDERS_INVOICES_DT_FILTERS:
      state = {
        ...state,
        ...action.payload.filters,
        notary: action.payload.filters.notary || state.notary,
        _set: true,
      };
      break
    case UNSET_ORDERS_INVOICES_DT_FILTERS:
      state = {
        ...state,
        _set: false,
      };
      break
  }
  return state;
}

export default combineReducers({
  Dt,
  DtFilters,
});